module.exports = __webpack_public_path__ + "media/maps/new-map-icon-e16cae8b.svg";